<template>
  <div class="oblig">
    <h1>Obligatorisk oppgave {{ id }}</h1>

    <div class="grid-container">
      <div class="grid-item">
        <div
          v-for="(modul, mod) in this.$store.state.mandatoryAssignments.modules"
          v-bind:key="mod"
        >
          <div v-for="(assignment, asg) in modul.assignments" v-bind:key="asg">
            <VueShowdown
              v-if="assignment.taskNumber == id.slice(2, 3) && modul.name.slice(6, 7) == id.slice(0, 1)"
              :markdown="assignment.text"
            />
          </div>
        </div>
      </div>

      <div class="delivering-section grid-item">
        <p>
          Obligatorisk oppgave leveres til:
          <strong
            ><a href="mailto:oblig@getacademy.no"
              >oblig@getacademy.no</a
            ></strong
          >
        </p>
        <p>E-posten skal inneholde dette:</p>

        <p>Lenke til et GitHub-repository som inneholde koden som er laget.</p>
        <p>
          Lenke til GitHub-pages, hvor applikasjonen skal kunne kjøres direkte.
        </p>

        <div>
          <LinkButton href="mailto:oblig@getacademy.no" text="Levér inn" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Oblig",
  data() {
    return {
      id: this.$route.params.id,
    };
  },
  props: {
    text: String,
  },
};
</script>

<style lang="scss" scoped>
.grid-item {
  margin-right: 4em;
}

.grid-container {
  display: flex;
  flex-direction: row;
}

.delivering-section {
  border: 1px solid black;
  border-radius: var(--border-radius);
  padding: 1em;
  margin: 0 auto auto;

  p:first-child {
    margin-top: 0;
  }
}

//Mobil CSS
@media only screen and (max-width: 768px) {

  .grid-container {
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
  }
}
</style>